import DataPayroll from '../../../views/Personnel/Payroll/DataPayroll.payroll.view';

export default DataPayroll;
